exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formInline[data-v-106edede] {\n  margin-top: 10px;\n  height: 50px;\n}\n.table[data-v-106edede] {\n  margin-top: 16px;\n}\n", ""]);

// exports
